import { useFormContext, useController } from 'react-hook-form';
import { FormType } from '../../shared/models/form';
import { useTranslation } from 'react-i18next';

const LowestFare = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<FormType>();
  const {
    field: { onChange, onBlur, value, ref, name },
  } = useController({ control, name: 'lowestFare' });

  return (
    <div className="flex-1">
      <div className="flex items-center h-full">
        <input
          type="checkbox"
          id={name}
          className="form-checkbox p-2.5 mr-2 rounded text-gray-500 focus:outline-gray-500 focus:ring-gray-500 focus:border-gray-500 focus:ring-offset-nok-800 focus:outline-offset-2"
          onChange={onChange}
          onBlur={onBlur}
          checked={value}
          ref={ref}
          name={name}
        />
        <label className="block text-sm" htmlFor={name}>
          {t('Lowest fare')}
        </label>
      </div>
    </div>
  );
};

export default LowestFare;
